import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenValidationService } from '../services/token-validation.service';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private tokenValidationService: TokenValidationService,
    private auth: AuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Validar el token antes de cada petición
    if (!this.tokenValidationService.isTokenValid()) {
      return this.handleAuthError(request, next);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handleAuthError(request, next);
        }
        return throwError(() => error);
      })
    );
  }

  private handleAuthError(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      // Intentar renovar el token
      return this.auth.getAccessTokenSilently().pipe(
        switchMap(token => {
          this.isRefreshing = false;
          // Actualizar el token en localStorage
          localStorage.setItem('token', token);
          // Reintentar la petición original con el nuevo token
          const newRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(newRequest);
        }),
        catchError(error => {
          this.isRefreshing = false;
          this.tokenValidationService.isTokenValid(); // Esto forzará el logout
          return throwError(() => error);
        })
      );
    }

    return throwError(() => new Error('Token inválido o expirado'));
  }
} 